module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Overseas Agent SOA")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('b-button', {
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.showExcelFunc(_vm.excelUploadFlag)
      }
    }
  }, [_vm._v("Import\n              SOA")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReportsReverse('Overseas_Agent_SOA_EXCEL', 'Export')
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName) + "\n              "), (_vm.ExcelBtnName != 'Export') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Filter-Agency-Modal'), _vm._v(" "), _c('FilterCBModal'), _vm._v(" "), _c('ClientCard'), _vm._v(" "), _c('ShipmentTrackCard')], 1)], 1)], 1), _vm._v(" "), _c('b-card', [_c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("To")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllAgentColoaderList'],
      "option-value": "agentName",
      "option-text": "agentName",
      "placeholder": "Select To"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.ToFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ToFilter", $$v)
      },
      expression: "Filter.ToFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Invoice Date :")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": _vm.SearchFilter
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Payment Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.filterstatusList,
      "option-value": "payVal",
      "option-text": "payText",
      "placeholder": "Select Status"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.statusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "statusFilter", $$v)
      },
      expression: "Filter.statusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.NoteTypeList,
      "option-value": "payVal",
      "option-text": "payText",
      "placeholder": "Select Status"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.NoteTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "NoteTypeFilter", $$v)
      },
      expression: "Filter.NoteTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type To Search (Assignment No. / Client / Container No. / Shipping Line / BL NO / CR/DR NO / HBL )"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.CommonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "CommonFilter", $$v)
      },
      expression: "Filter.CommonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.branchfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchfilter", $$v)
      },
      expression: "Filter.branchfilter"
    }
  })], 1), _vm._v(" "), (_vm.excelUploadFlag) ? _c('b-col', {
    staticClass: "col-md-3 mt-4"
  }, [_c('label', [_vm._v("Upload File")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": ".xlsx, .xls,.csv"
    },
    on: {
      "change": _vm.onFileChange
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "align-content-end mt-3"
  }, [_c('b-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCheckAll),
      expression: "isCheckAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCheckAll) ? _vm._i(_vm.isCheckAll, null) > -1 : (_vm.isCheckAll)
    },
    on: {
      "click": function($event) {
        _vm.SelectAll(_vm.CDCRARR)
      },
      "change": function($event) {
        var $$a = _vm.isCheckAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isCheckAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isCheckAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCheckAll = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Select / Deselect All Count(" + _vm._s(this.note_ids.length) + ")")]), _vm._v(" "), (_vm.note_ids.length > 0) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.ProceedMultiPayment
    }
  }, [_vm._v("Multi Payment")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('h5', {
    staticClass: "text-muted pull-right"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "padding": "0px 1rem 0 5rem"
    },
    attrs: {
      "cols": "2"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.PaginationList,
      "option-value": "pagv",
      "option-text": "pagt",
      "placeholder": "Select"
    },
    on: {
      "input": function($event) {
        _vm.pagechangeData()
      }
    },
    model: {
      value: (_vm.PaginationCount),
      callback: function($$v) {
        _vm.PaginationCount = $$v
      },
      expression: "PaginationCount"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.CDCRARR,
      "responsive": "",
      "fields": _vm.Columns,
      "primary-key": "note_id",
      "per-page": _vm.pagination.perPage,
      "current-page": _vm.pagination.currentPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "note_id",
      fn: function(row0) {
        return [(row0.item.payStatus != '1' && row0.item.payStatus != '2') ? _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.note_ids),
            expression: "note_ids"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "value": row0.item.note_id,
            "checked": Array.isArray(_vm.note_ids) ? _vm._i(_vm.note_ids, row0.item.note_id) > -1 : (_vm.note_ids)
          },
          on: {
            "change": [function($event) {
              var $$a = _vm.note_ids,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = row0.item.note_id,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.note_ids = $$a.concat([$$v]))
                } else {
                  $$i > -1 && (_vm.note_ids = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.note_ids = $$c
              }
            }, function($event) {
              _vm.updateSelectAll($event, row0.item)
            }]
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("\n              " + _vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage) + "\n            ")])]
      }
    }, {
      key: "noteSeries",
      fn: function(row1) {
        return [_c('span', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v("\n              CR/DR No.:\n              "), _c('b', [_vm._v(_vm._s(row1.item.noteSeries))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v("\n              Created:\n              "), _c('b', [_vm._v(_vm._s(row1.item.noteDate))])]), _vm._v(" "), _c('br')]
      }
    }, {
      key: "note_type",
      fn: function(row2) {
        return [_c('span', {
          attrs: {
            "variant": "info"
          }
        }, [_c('b', [_vm._v("\n                " + _vm._s(row2.item.note_type == "CR" ? "Credit" : "Debit") + "\n              ")])]), _vm._v(" "), _c('br')]
      }
    }, {
      key: "AgentColoader",
      fn: function(row3) {
        return [_c('span', {
          attrs: {
            "variant": "info"
          }
        }, [_c('b', [_vm._v(_vm._s(row3.item.AgentColoader))])]), _vm._v(" "), _c('br')]
      }
    }, {
      key: "mainSalesSeries",
      fn: function(row4) {
        return [_c('span', [_vm._v("\n              Ass No:\n              "), _c('b', [_vm._v(_vm._s(row4.item.mainSalesSeries))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n              Ass Date:\n              "), _c('b', [_vm._v(_vm._s(row4.item.assDate))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n              Ass Branch:\n              "), _c('b', [_vm._v(_vm._s(row4.item.raisedFrom))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "assign_date": row4.item.assDate,
            "assign_job_type": '',
            "assign_raised_from": 'Raised From: ' + row4.item.raisedFrom,
            "assign_raised_by": 'Raised By: ',
            "fk_all_module_id": row4.item.allModuleId,
            "jb_series": row4.item.mainSalesSeries,
            "fk_client_id": '',
            "fk_pod_id": ''
          }
        }), _vm._v(" "), (row4.item.allModuleId) ? _c('JobWisePaymentsDetails', {
          attrs: {
            "allModuleId": Number(row4.item.allModuleId),
            "JobNo": row4.item.mainSalesSeries
          }
        }) : _vm._e(), _vm._v(" "), (row4.item.allModuleId) ? _c('RejectInvTallyBillSummary', {
          attrs: {
            "PMC_title": 'Invoice Rejection Log Summary Job No - ' + row4.item.mainSalesSeries,
            "PMC_JOBID": row4.item.allModuleId.toString(),
            "PMC_JOBNO": row4.item.mainSalesSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (row4.item.allModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row4.item.mainSalesSeries,
            "PMC_JOBID": row4.item.allModuleId,
            "PMC_JOBNO": row4.item.mainSalesSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e()]
      }
    }, {
      key: "noteAmount",
      fn: function(row5) {
        return [_c('span', {
          attrs: {
            "variant": "info"
          }
        }, [_c('b', [_vm._v("\n                " + _vm._s(row5.item.totalAmt + " " + row5.item.currencyName) + "\n              ")])]), _vm._v(" "), _c('br'), _vm._v(" "), (row5.item.payMode == 1) ? _c('b', [_c('b-badge', {
          staticClass: "p-1 mt-1",
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("RTGS")])], 1) : (row5.item.payMode == 2) ? _c('b', [_c('b-badge', {
          staticClass: "p-1 mt-1",
          attrs: {
            "size": "sm",
            "variant": "info"
          }
        }, [_vm._v("Cheque")])], 1) : (row5.item.payMode == 3) ? _c('b', [_c('b-badge', {
          staticClass: "p-1 mt-1",
          attrs: {
            "size": "sm",
            "variant": "warning"
          }
        }, [_vm._v("Online")])], 1) : _vm._e()]
      }
    }, {
      key: "action",
      fn: function(row4) {
        return [(row4.item.note_id) ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-success"
          },
          on: {
            "click": function($event) {
              _vm.openpaymentModal(row4.item)
            }
          }
        }, [_vm._v("Pay")]) : _vm._e(), _vm._v(" "), (row4.item.note_id) ? _c('b-button', {
          staticClass: "mt-1",
          attrs: {
            "size": "sm",
            "variant": "warning"
          },
          on: {
            "click": function($event) {
              _vm.PrintNote(row4.item.mainSalesSeries, row4.item.uploadCreditDebit)
            }
          }
        }, [_vm._v("PDF")]) : _vm._e(), _vm._v(" "), (row4.item.payStatus == 1) ? _c('b', [_c('b-badge', {
          staticClass: "p-1 mt-1",
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Paid")])], 1) : _c('b', [_c('b-badge', {
          staticClass: "p-1 mt-1",
          attrs: {
            "size": "sm",
            "variant": "warning"
          }
        }, [_vm._v("Pending")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('h5', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    attrs: {
      "limit": "8",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('b-modal', {
    ref: "payment-Modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.paymentModal.creditDebitNoteType == 'CR' ?
        'CREDIT NOTE Payment Details' :
        'DEBIT NOTE Payment Details'
    }
  }, [_c('b-row', {
    staticClass: "justify-content-center"
  }, [_c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("\n          Invoice No.\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), (_vm.paymentModal.uploadCreditDebit && _vm.paymentModal.noteSeries) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.PrintNote(_vm.paymentModal.assignmentNo, _vm.paymentModal.uploadCreditDebit)
      }
    }
  }, [(_vm.paymentModal.noteSeries) ? _c('b', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.paymentModal.noteSeries) + "\n          ")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('label', [_vm._v("\n          Invoice Amount\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": _vm.paymentModal.payAmount ? true : false,
      "name": "payAmount",
      "id": "payAmount",
      "type": "number"
    },
    model: {
      value: (_vm.paymentModal.payAmount),
      callback: function($$v) {
        _vm.$set(_vm.paymentModal, "payAmount", $$v)
      },
      expression: "paymentModal.payAmount"
    }
  }), _vm._v(" "), (!_vm.paymentModal.payAmount ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorPayment.payAmount) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('label', [_vm._v("\n          Currency\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.paymentModal.payCurrencyId &&
        _vm.paymentModal.payStatus &&
        _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "list": _vm.$store.getters['common/getAllCurrencyList'],
      "option-value": "currency_id",
      "option-text": "currencyCode",
      "placeholder": "Select Currency"
    },
    model: {
      value: (_vm.paymentModal.payCurrencyId),
      callback: function($$v) {
        _vm.$set(_vm.paymentModal, "payCurrencyId", $$v)
      },
      expression: "paymentModal.payCurrencyId"
    }
  }), _vm._v(" "), (!_vm.paymentModal.payCurrencyId ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorPayment.payCurrencyId))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('label', [_vm._v("\n          Payment Mode\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.paymentModal.payMode && _vm.paymentModal.payStatus ? true : false,
      "list": _vm.payList,
      "option-value": "payVal",
      "option-text": "payText",
      "placeholder": "Select Payment Mode"
    },
    model: {
      value: (_vm.paymentModal.payMode),
      callback: function($$v) {
        _vm.$set(_vm.paymentModal, "payMode", $$v)
      },
      expression: "paymentModal.payMode"
    }
  }), _vm._v(" "), (!_vm.paymentModal.payMode ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorPayment.payMode) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('label', [_vm._v("\n          Payment Ref\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": _vm.paymentModal.payRef &&
        _vm.paymentModal.payStatus &&
        _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "name": "payRef",
      "id": "payRef",
      "type": "text"
    },
    model: {
      value: (_vm.paymentModal.payRef),
      callback: function($$v) {
        _vm.$set(_vm.paymentModal, "payRef", $$v)
      },
      expression: "paymentModal.payRef"
    }
  }), _vm._v(" "), (!_vm.paymentModal.payRef ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorPayment.payRef) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('label', [_vm._v("\n          Payment Amount\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": _vm.paymentModal.paidAmount &&
        _vm.paymentModal.payStatus &&
        _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "name": "payAmount",
      "id": "payAmount",
      "type": "number"
    },
    model: {
      value: (_vm.paymentModal.paidAmount),
      callback: function($$v) {
        _vm.$set(_vm.paymentModal, "paidAmount", $$v)
      },
      expression: "paymentModal.paidAmount"
    }
  }), _vm._v(" "), (!_vm.paymentModal.paidAmount ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorPayment.paidAmount) + "\n        ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('label', [_vm._v("Payment Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.paymentModal.payStatus &&
        _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "list": _vm.statusList,
      "option-value": "payVal",
      "option-text": "payText",
      "placeholder": "Select Status"
    },
    model: {
      value: (_vm.paymentModal.payStatus),
      callback: function($$v) {
        _vm.$set(_vm.paymentModal, "payStatus", $$v)
      },
      expression: "paymentModal.payStatus"
    }
  }), _vm._v(" "), (!_vm.paymentModal.payStatus ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorPayment.payStatus) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('label', [_vm._v("\n          Payment Date\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.paymentModal.payDate && _vm.paymentModal.payStatus ? true : false,
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "payDate",
      "id": "payDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.paymentModal.payDate),
      callback: function($$v) {
        _vm.$set(_vm.paymentModal, "payDate", $$v)
      },
      expression: "paymentModal.payDate"
    }
  }), _vm._v(" "), (!_vm.paymentModal.payDate ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorPayment.payDate) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('label', {
    attrs: {
      "for": "Remarks"
    }
  }, [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "3"
    },
    model: {
      value: (_vm.paymentModal.remark),
      callback: function($$v) {
        _vm.$set(_vm.paymentModal, "remark", $$v)
      },
      expression: "paymentModal.remark"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "10"
    }
  }, [(_vm.paymentModal.note_id) ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "disabled": _vm.paymentModal.crdr_id &&
        _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "variant": "success"
    },
    on: {
      "click": _vm.submitPayment
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hidepaymentModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "Multi-Payment-Modal",
    attrs: {
      "id": "Multi-Payment-Modal",
      "title": "Multi Payment",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('label', [_vm._v("\n          Payment Date\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "name": "payDate",
      "id": "payDate",
      "type": "datetime",
      "format": "YYYY-MM-DD hh:mm a",
      "minute-step": 1
    },
    model: {
      value: (_vm.MultiPayment.payDate),
      callback: function($$v) {
        _vm.$set(_vm.MultiPayment, "payDate", $$v)
      },
      expression: "MultiPayment.payDate"
    }
  }), _vm._v(" "), (!_vm.MultiPayment.payDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorMultiPayment.payDate) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('label', [_vm._v("\n          Payment Ref\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "payRef",
      "id": "payRef",
      "type": "text"
    },
    model: {
      value: (_vm.MultiPayment.payRef),
      callback: function($$v) {
        _vm.$set(_vm.MultiPayment, "payRef", $$v)
      },
      expression: "MultiPayment.payRef"
    }
  }), _vm._v(" "), (!_vm.MultiPayment.payRef ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorMultiPayment.payRef) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('label', [_vm._v("\n          Payment Remark\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "5",
      "id": "name-input"
    },
    model: {
      value: (_vm.MultiPayment.remark),
      callback: function($$v) {
        _vm.$set(_vm.MultiPayment, "remark", $$v)
      },
      expression: "MultiPayment.remark"
    }
  }), _vm._v(" "), (!_vm.MultiPayment.remark) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorMultiPayment.remark) + "\n        ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-button', {
    staticClass: "sm",
    attrs: {
      "disabled": _vm.MultiPayment.remark && _vm.MultiPayment.payDate ? false : true,
      "variant": "success"
    },
    on: {
      "click": _vm.PayMultiPayment
    }
  }, [_vm._v("Pay")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right sm",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closeMultiPaymentModal
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-214a9d45","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Overseas/overseasAgentSoa.vue
// module id = 2453
// module chunks = 0